module.exports = __webpack_public_path__ + "static/img/indexText4.1f85b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexText4.png
// module id = zNiw
// module chunks = 1